import { Outlet,ScrollRestoration } from 'react-router-dom';
import { Navigation } from '../components/navigation';
import '../index.css'
export default function Layout() {
  return (
    <>
      <Navigation />
      <Outlet />
      <ScrollRestoration/>
    </>
  );
}
